<template>
  <v-container class="d-flex flex-column align-center"
               fluid>
    <centered-loading :displayBool="true"
                      :completedBool="!loading"
                      :successBool="true"
                      :displayText="text"
                      class="mt-10">
    </centered-loading>
    <v-card class="mt-16 pa-5 d-flex"
            width="80%">
      <h2 v-text="'Old to new'"
          class="mr-5" />
      <v-text-field dense
                    hide-details
                    class="mr-5"
                    label="Input URL"
                    v-model="inOldURL"> </v-text-field>
      <v-btn class="px-6"
             color="green"
             dark
             @click="start()">Test </v-btn>
    </v-card>
    <v-card class="mt-7 pa-5 d-flex justify-space-between align-center"
            width="80%">
      <h2 v-text="'Result'" />
      <h4 v-text="redirectroute" />
      <v-btn :to="redirectroute"
             color="primary"
             class="px-7">Go2</v-btn>
    </v-card>
  </v-container>
</template>

<script>
import CenteredLoading from "@/components/Sections/CenteredLoading.vue";
import PageMap from "@/router/PageMap";
import ParamMap from "@/router/ParamMap";

export default {
  name: "PageParseRedirect",
  components: { CenteredLoading },

  data() {
    return {
      loading: false,
      path: this.$route.path,
      text: "Redirecting...",

      inOldURL: null,
      originurl: null,
      subpage: "",

      pagemap: PageMap,
      parammap: ParamMap,

      redirectroute: {},
    };
  },

  mounted() {
    this.inOldURL = this.$route.query.page;
    
    this.start();
  },

  methods: {
    start() {
      this.loading = true;
      this.prosessURL();
    },

    prosessURL() {
      this.originurl = new URL(this.inOldURL);
      this.subpage = this.originurl.pathname;
      this.subpage = this.subpage.replace("/ServiceProviderWebSite/Views/", "");

      //workarround for new pages, tho old page uses id 0 for new objects regardless of page
      if (this.inOldURL.includes("?id=0")) {
        this.subpage = this.subpage + "?id=0";
      }
      if (this.subpage === "Job/ManageJob.aspx" && !this.inOldURL.includes("?leftmenuid=")) {
        this.subpage = this.subpage + "?landingpage";
      }
      //workarround for myjobs, status 0 is used for myjobs in the old system
      if (this.inOldURL.includes("?leftmenuid=0")) {
        this.subpage = this.subpage + "?leftmenuid=0";
      }
      //workarround for partsjobs, status -2 is used for partsjobs in the old system
      if (this.inOldURL.includes("?leftmenuid=-2")) {
        this.subpage = this.subpage + "?leftmenuid=-2";
      }
      console.log("[ReDir] subpage", this.subpage);
      this.getEndpoint();
    },

    getEndpoint() {
      this.text = "Calculating endpoint...";
      var page = null;
      for (let [key, value] of this.pagemap.entries()) {
        if (value === this.subpage) {
          page = key;
          break;
        }
      }
      console.log("[ReDir] page", page);
      page = page ? page : "Home";
      this.redirectroute.name = page;
      console.log("[ReDir] redirectroute name", page);
      this.getParams();
    },

    getParams() {
      this.text = "Setting paramters...";

      let pageparams = new Map([
        ["job", { statusId: 0, subStatusId: 0, jobId: 0 }],
        ["customer", { customerId: 0 }],
      ]);

      var paramlist = {};
      for (let page of pageparams.keys()) {
        if (this.redirectroute.name.toUpperCase().includes(page.toUpperCase())) {
          paramlist = pageparams.get(page);
          break;
        }
      }

      var params = {};
      for (const key in paramlist) {
        const foreginkey = this.parammap.get(key);
        const value = this.originurl.searchParams.get(foreginkey);
        params[key] = value ? value : undefined;
      }

      if (this.inOldURL.includes("Job/ManageJobEdit")) {
        params["filter"] = "my";
      }

      this.redirectroute.params = params;
      console.log("[ReDir] redirectroute params", params);
      this.getQueries();
    },

    getQueries() {
      this.text = "Setting queries...";
      //there is no map for queries as of witing this
      this.redirectroute.query = undefined;
      this.redirect();
    },

    redirect() {
      this.text = "Redirecting...";
      this.loading = false;
      console.log("[ReDir] redirect", this.redirectroute);
      this.$router.replace(this.redirectroute);
    },
  },

  computed: {},

  watch: {
    inOldURL: function () {
      if (this.inOldURL != this.$route.query.page) {
        this.$router.replace({ query: { page: this.inOldURL } });
      }
    },

    inNewURL: function () {
      this.$router.replace({ query: { page: this.inNewURL } });
    },

    "$route.query.page": function () {
      if (this.inOldURL != this.$route.query.page) {
        this.inOldURL = this.$route.query.page;
      }
    },
  },
};
</script>